import React from "react";
import { useQuery } from "@tanstack/react-query";
import Image from "next/image";
import Link from "next/link";
import { CartItem } from "../../types/cart";
import { Product } from "../../types/product";
import productCore from "../../core/product.core";
import { getProductUrl } from "../../core/productUrl.core";
import { useTranslation } from "../../core/translation.core";
import { useRouter } from "next/router";
import useProductSingle from "../../hooks/productSingle.hook";

interface BundleItemDetailsProps {
  item: CartItem;
}

export function BundleItemDetails({ item }: BundleItemDetailsProps) {
  const { t, msg } = useTranslation();

  if (item.product.productType !== "bundle") return null;
  if (!item.bundleSelections) return null;

  return (
    <div className="mt-3 pl-4 border-l-2 border-gray-200 dark:border-gray-700">
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">{t(msg.product.bundleIncludes)}:</p>
      <div className="space-y-2">
        {item.bundleSelections.map((productItem) => (
          <BundleItemRow key={productItem.bundleItemProductId} item={item} productItem={productItem} />
        ))}
      </div>
    </div>
  );
}

interface BundleItemRowProps {
  item: CartItem;
  productItem: {
    bundleItemProductId: string;
    selectedVariationId?: string;
  };
  // bundleProduct: {
  //   productId: string;
  //   quantity: number;
  //   allowedVariationIds: string[];
  // };
  // bundleSelections?: Array<{
  //   bundleItemProductId: string;
  //   selectedVariationId: string;
  //   selectedVariation?: Product;
  // }>;
}

function BundleItemRow({ item, productItem }: BundleItemRowProps) {
  const { data: product } = useProductSingle(productItem.bundleItemProductId);
  const { data: selectedVariation } = useProductSingle(productItem.selectedVariationId);

  if (!product) {
    return (
      <div className="flex items-center gap-2 text-xs animate-pulse">
        <div className="w-8 h-8 bg-gray-200 rounded"></div>
        <div className="flex-1 h-4 bg-gray-200 rounded"></div>
      </div>
    );
  }

  const displayProduct = selectedVariation || product;
  const displayImage = displayProduct.featureMedia?.url || "/images/logo-square.webp";

  const bundleProduct = item.product.bundleProducts?.find(
    (bundleProduct) => bundleProduct.productId === productItem.bundleItemProductId
  );

  return (
    <div className="flex items-center gap-2">
      <div className="relative w-8 h-8 flex-shrink-0">
        <Image src={displayImage} alt={displayProduct.name} fill className="object-contain" sizes="32px" unoptimized />
      </div>
      <div className="">
        <p>
          {displayProduct.name} x{bundleProduct?.quantity}
        </p>
        {selectedVariation && (
          <span className="bg-yellow-400 px-2 rounded-lg">
            ({selectedVariation.attributes?.find((attr) => attr.code === "variant")?.value})
          </span>
        )}
      </div>
    </div>
  );
}
